module.exports = __webpack_public_path__ + "img/vertical_3_3_9016.c5ec93e8.png";